import { Component, ContentChild, Input, OnChanges, SimpleChanges, TemplateRef } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { CustomErrorStateMatcher, PromptConfirmDialogComponent } from "@merri/common";
import { of, take } from "rxjs";
import { ValidatorService } from "src/app/core/services/validator.service";

@Component({
    selector: "app-linked-partners",
    templateUrl: "./linked-partners.component.html",
    styleUrls: ["./linked-partners.component.scss"],
    standalone: false
})
export class LinkedPartnersComponent implements OnChanges {
  @Input() form: UntypedFormGroup | FormGroup;
  @Input() matcher: CustomErrorStateMatcher;
  @Input() controlName: string;
  @Input() partnerIds: number[];

  @ContentChild("controlsTemplate") controlsTemplateRef: TemplateRef<void>;

  constructor(private formBuilder: FormBuilder, private _validatorService: ValidatorService, private matDialog: MatDialog) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.partnerIds || changes.form || changes.controlName) {
      this.set();
    }
  }

  get linkedPartners(): FormArray {
    if (!this.controlName) return null;
    if (!this.form) return null;

    return this.form.get(this.controlName) as FormArray;
  }

  onAddLinkedPartner(): void {
    this.linkedPartners?.push(this.newLinkedPartner());
  }

  onDeleteLinkedParter(index: number): void {
    const deletedPartnerLink = this.linkedPartners?.at(index)?.value;
    if (!deletedPartnerLink) return;

    const obs = deletedPartnerLink.partnerId
      ? PromptConfirmDialogComponent.promptYesConfirm$(
          this.matDialog,
          `Are you sure you want to remove this mapping?\n\n${deletedPartnerLink.partnerId} - ${deletedPartnerLink.partnerName ?? ""}`,
        )
      : of(true);

    obs.pipe(take(1)).subscribe({
      next: result => {
        if (result) {
          this.linkedPartners?.removeAt(index);
        }
      },
    });
  }

  private set(): void {
    if (!this.form) return;
    if (!this.controlName) return;

    this.linkedPartners?.clear({ emitEvent: false });

    if (this.partnerIds?.length) {
      this.partnerIds.forEach(partnerId => {
        this.linkedPartners?.push(this.newLinkedPartner(partnerId.toString()));
      });
    }
  }

  private newLinkedPartner(partnerId?: string): FormGroup {
    return this.formBuilder.group({
      partnerId: [partnerId, Validators.required, this._validatorService.validatePartnerId()],
      partnerName: null,
    });
  }
}
